import {
  Activity,
  ArrowLeftRight,
  Banknote,
  BarChart3,
  Boxes,
  Building2,
  CalendarClock,
  CalendarDays,
  ClipboardList,
  Copy,
  FileUp,
  FlaskConical,
  ImageIcon,
  Info,
  LayoutGrid,
  Link2,
  Monitor,
  Printer,
  Package,
  PlugZap,
  Receipt,
  ScanSearch,
  ShieldCheck,
  Tags,
  TrendingUp,
  Users,
  type LucideIcon,
} from 'lucide-react'

/**
 * Значки меню по смысловому имени из дескриптора окна (`menu.icon`). Набор —
 * тот же, что у окон прежнего клиента: РМК — монитор, номенклатура — коробка,
 * поставки — ящики. Пакеты React-иконок не знают; неизвестное имя — общий значок.
 */
const ICONS: Readonly<Record<string, LucideIcon>> = {
  sale: Monitor,
  receipts: Receipt,
  'cashier-stats': BarChart3,
  cashiers: Users,
  'sales-stats': TrendingUp,
  shifts: CalendarClock,
  schedule: CalendarDays,
  catalog: Package,
  'photo-search': ScanSearch,
  photo: ImageIcon,
  duplicates: Copy,
  supplies: Boxes,
  prices: Banknote,
  inventory: ClipboardList,
  'price-tags': Tags,
  import: FileUp,
  structure: Building2,
  resources: PlugZap,
  sync: ArrowLeftRight,
  links: Link2,
  access: ShieldCheck,
  diagnostics: Activity,
  testing: FlaskConical,
  about: Info,
  hardware: Printer,
}

export function MenuIcon({ name, size = 18 }: { name: string | null; size?: number }) {
  const Icon = (name === null ? undefined : ICONS[name]) ?? LayoutGrid
  return <Icon size={size} aria-hidden="true" />
}
